<template>
  <div>
    <div
      v-show="!loading && src"
      class="w-full relative"
      :class="containerClass"
    >
      <img
        :src="src"
        :class="imgClass"
        :alt="alt"
        @load="
          () => {
            loading = false;
          }
        "
      />
    </div>
    <div
      v-if="loading"
      :class="imgClass"
      class="w-full h-full animated-shimmer pointer-events-none"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:svgjs="http://svgjs.dev/svgjs"
        width="100%"
        height="100%"
        :viewBox="`0 0 ${500} ${500 / aspectRation}`"
        style=""
      ></svg>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdvanceImage",
  props: {
    aspectRation: {
      type: Number,
      default: 0.8,
    },
    src: String,
    imgClass: String,
    containerClass: String,
    alt: {
      type: String,
      default: "thumb image",
    },
  },
  data() {
    return {
      loading: true,
    };
  },
};
</script>

<style lang="scss" scoped></style>
